import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { Bookmark, Loader2 } from 'lucide-react';

function WantToTryButton({ barId, size = 'default', showLabel = true }) {
  const { isInWantToTry, toggleWantToTry } = useApp();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const inWantToTry = isInWantToTry(barId);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!user) return;
    
    setLoading(true);
    try {
      await toggleWantToTry(barId);
    } catch (err) {
      console.error('Error toggling Want to Try:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  const sizeClasses = {
    small: 'p-1.5',
    default: 'p-2',
    large: 'p-3'
  };

  const iconSizes = {
    small: 'w-4 h-4',
    default: 'w-5 h-5',
    large: 'w-6 h-6'
  };

  if (showLabel) {
    return (
      <button
        onClick={handleClick}
        disabled={loading}
        className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all ${
          inWantToTry
            ? 'bg-amber-500/20 text-amber-400 border border-amber-500/50'
            : 'bg-dive-dark text-gray-400 border border-dive-gray hover:border-gray-500 hover:text-white'
        }`}
        title={inWantToTry ? 'Remove from Want to Try' : 'Add to Want to Try'}
      >
        {loading ? (
          <Loader2 className={`${iconSizes[size]} animate-spin`} />
        ) : (
          <Bookmark 
            className={`${iconSizes[size]} ${inWantToTry ? 'fill-amber-400' : ''}`}
          />
        )}
        <span className="text-sm">
          {inWantToTry ? 'Want to Try' : 'Want to Try'}
        </span>
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className={`${sizeClasses[size]} rounded-lg transition-all ${
        inWantToTry
          ? 'bg-amber-500/20 text-amber-400'
          : 'bg-dive-dark text-gray-400 hover:text-amber-400'
      }`}
      title={inWantToTry ? 'Remove from Want to Try' : 'Add to Want to Try'}
    >
      {loading ? (
        <Loader2 className={`${iconSizes[size]} animate-spin`} />
      ) : (
        <Bookmark 
          className={`${iconSizes[size]} ${inWantToTry ? 'fill-amber-400' : ''}`}
        />
      )}
    </button>
  );
}

export default WantToTryButton;


